export const statusesMap = new Map<boolean, "success" | "error">([
  [true, "success"],
  [false, "error"],
])
